import React, { useEffect, useRef } from 'react';
import { ValidatedTextarea } from '@cp-shared-19/frontend-ui';

type TextAreaProps = {
    label: string;
    name: string;
    placeholder?: string;
    isMandatory?: boolean;
};

export const TextArea: React.FC<TextAreaProps> = ({ label, name, placeholder, isMandatory = true }) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const hiddenEl = wrapperRef.current?.querySelector('.u-visually-hidden');
        if (!hiddenEl) {
            return;
        }

        const translateCounterText = (text: string): string => {
            const hintMatch = text.match(/^You can enter up to\s+(\d+)\s+characters\.?$/i);
            if (hintMatch) {
                return `Vous pouvez saisir jusqu'a ${hintMatch[1]} caracteres.`;
            }

            const remainingMatch = text.match(/^You have\s+(\d+)\s+characters remaining\.?$/i);
            if (remainingMatch) {
                return `Il vous reste ${remainingMatch[1]} caracteres.`;
            }

            return text;
        };

        const applyFrenchCounterTexts = () => {
            hiddenEl.querySelectorAll('div').forEach((el) => {
                const originalText = el.textContent?.trim();
                if (!originalText) {
                    return;
                }

                const translatedText = translateCounterText(originalText);
                if (translatedText !== originalText) {
                    el.textContent = translatedText;
                }
            });
        };

        applyFrenchCounterTexts();

        const observer = new MutationObserver(() => applyFrenchCounterTexts());
        observer.observe(hiddenEl, { childList: true, subtree: true, characterData: true });

        return () => observer.disconnect();
    }, []);

    return (
        <div ref={wrapperRef} lang="fr">
            <ValidatedTextarea
                label={label}
                name={name}
                testId={`test-${name}`}
                placeholder={placeholder}
                maxLength={1000}
                aria-required={isMandatory}
                required={isMandatory}
                isMandatory={isMandatory}
                requiredText=" *"
            />
        </div>
    );
};
